import store from '../store'
import VueRouter from 'vue-router'

import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
// import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'
// import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// import Charts from 'src/components/Dashboard/Views/Charts.vue'

// Grab Console
import Dashboard from 'src/components/Dashboard/Views/Dashboard.vue'

// Servers Section
import ServersList from 'src/components/Dashboard/Views/Servers/List.vue'
import ServersView from 'src/components/Dashboard/Views/Servers/View.vue'

// Licences Section
import LicensesList from 'src/components/Dashboard/Views/Licenses/List.vue'
import LicensesView from 'src/components/Dashboard/Views/Licenses/View.vue'

// Decrypt Keys Section
import DecryptKeysList from 'src/components/Dashboard/Views/DecryptKey/List.vue'

// VOD sets Section
import VodSetsList from 'src/components/Dashboard/Views/VodSets/List.vue'

// Grab Process Section
import GrabProcessList from 'src/components/Dashboard/Views/GrabProcess/List.vue'
import GrabProcessView from 'src/components/Dashboard/Views/GrabProcess/View.vue'

// DataViewer Section
import DataViewerTv from 'src/components/Dashboard/Views/DataViewer/TvGuide.vue'
import DataViewerVod from 'src/components/Dashboard/Views/DataViewer/VodGuide.vue'

import Channels from 'src/components/Dashboard/Views/Channels.vue'
import Logbook from 'src/components/Dashboard/Views/Logbook.vue'
import Settings from 'src/components/Dashboard/Views/Settings.vue'

import {componentsMenu, formsMenu, tablesMenu, mapsMenu, pagesMenu} from "./routes_demo";
import Login from "../components/Dashboard/Views/Pages/Login";
// import Register from "../components/Dashboard/Views/Pages/Register";
// import Lock from "../components/Dashboard/Views/Pages/Lock";
import ForgotPassword from "../components/Dashboard/Views/Pages/ForgotPassword";
import ResetPassword from "../components/Dashboard/Views/Pages/ResetPassword";

const routes = [
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        meta: {title: 'Dashboard'},
        component: Dashboard
      },
      {
        path: 'servers',
        name: 'servers',
        meta: {title: 'Servers'},
        component: ServersList
      },
      {
        path: 'servers/view/:id',
        name: 'server.view',
        meta: {title: 'Server Configuration'},
        component: ServersView
      },
      {
        path: 'grabjobs',
        name: 'grabjobs',
        meta: {title: 'Grab Jobs'},
        component: GrabProcessList
      },
      {
        path: 'grabjobs/view/:id',
        name: 'grabjobs.view',
        meta: {title: 'Grab Jobs'},
        component: GrabProcessView
      },
      {
        path: 'channels',
        name: 'channels',
        meta: {title: 'Channels'},
        component: Channels
      },
      {
        path: 'dataviewer/tv',
        name: 'dataviewer.tv',
        meta: {title: 'DataViewer - TV guide'},
        component: DataViewerTv
      },
      {
        path: 'dataviewer/vod',
        name: 'dataviewer.vod',
        meta: {title: 'DataViewer - VOD guide'},
        component: DataViewerVod
      },
      {
        path: 'logbook',
        name: 'logbook',
        meta: {title: 'Logbook'},
        component: Logbook
      },
      {
        path: 'licenses',
        name: 'licenses',
        meta: {title: 'Licenses'},
        component: LicensesList
      },
      {
        path: 'decrypt-keys',
        name: 'decryptkeys',
        meta: {title: 'Decrypt Keys'},
        component: DecryptKeysList
      },
      {
        path: 'vodsets',
        name: 'vodsets',
        meta: {title: 'VOD sets'},
        component: VodSetsList
      },
      {
        path: 'licenses/view/:id',
        name: 'license.view',
        meta: {title: 'License View'},
        component: LicensesView
      },
      {
        path: 'settings',
        name: 'settings',
        meta: {title: 'Global settings'},
        component: Settings
      }
    ]
  },
  // {
  //   path: '/',
  //   component: DashboardLayout,
  //   redirect: '/admin/dashboard',
  //   children: [
  //     {
  //       path: 'calendar',
  //       name: 'Calendar',
  //       meta: {title: 'Calendar'},
  //       component: Calendar
  //     },
  //     {
  //       path: 'charts',
  //       name: 'Charts',
  //       meta: {title: 'Charts'},
  //       component: Charts
  //     }
  //   ]
  // },
  // componentsMenu,
  // formsMenu,
  // tablesMenu,
  // mapsMenu,
  // pagesMenu,
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {title: 'Login', isPublic: true}
  },
  {
    path: '/forgot-password',
    name: 'forgot.password',
    component: ForgotPassword,
    meta: {title: 'ForgotPassword', isPublic: true}
  },
  {
    path: '/reset-password/token/:token/email/:email',
    name: 'reset.password',
    component: ResetPassword,
    meta: {title: 'ResetPassword', isPublic: true}
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   meta: {title: 'Register'},
  //   component: Register
  // },
  // {
  //   path: '/lock',
  //   name: 'Lock',
  //   meta: {title: 'Lock'},
  //   component: Lock
  // },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        meta: {title: 'Overview'},
        component: Overview
      },
      // {
      //   path: 'stats',
      //   name: 'Stats',
      //   meta: {title: 'Stats'},
      //   component: Stats
      // }
    ]
  },
  {path: '/', redirect: '/admin'},
  {path: '*', component: NotFound}
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = store.getters.isAuthenticated
  if (!to.matched.some(record => record.meta.isPublic)) {
    if (!isUserLoggedIn) {
      store.dispatch('logout')
      // next()
      next({
        name: 'login',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/routes/routes.js